import { trans } from '@spotahome/soyuz/client';

import LandingSection from '@spotahome/ui-library/src/tenant/components/LandingSection/LandingSection';
import LazyLoad from '@spotahome/ui-library/src/tenant/components/LazyLoad';

import './Quote.scss';

const Quote = () => (
  <LandingSection containerClassName="quote__section-container">
    <div className="quote">
      <p className="quote__text">
        {trans('tenant_guarantees.deposit.quote.text')}
      </p>
      <div className="quote__footer">
        <div className="quote__author">
          <p>Marta</p>
          <p>{trans('tenant_guarantees.deposit.quote.tenant')}</p>
        </div>
        <LazyLoad
          height={80}
          offset={100}
          once
          as="figure"
          className="quote__image"
        >
          <img
            height={80}
            width={80}
            src="https://static.spotahome.com/images/tenant-guarantee-quote.webp"
            alt="Marta"
          />
        </LazyLoad>
      </div>
    </div>
  </LandingSection>
);

export default Quote;
